import { FormContextValues } from '@dreryk/react-common';
import { TextInput } from '@dreryk/react-components';

import { translationKeys } from '../../../translations';

import { GroupSessionsNameFieldFormBeanPart } from './GroupSessionsNameField.types';

const GROUP_SESSIONS_NAME_MAX_LENGTH = 100;

type GroupSessionsNameFieldProps = Pick<FormContextValues<GroupSessionsNameFieldFormBeanPart>, 'register'>;

export const GroupSessionsNameField = (props: GroupSessionsNameFieldProps): JSX.Element => {
   return (
      <TextInput
         testId={'name'}
         label={translationKeys.name}
         placeholder={translationKeys.fillName}
         controller={props.register('name', { required: true, maxLength: GROUP_SESSIONS_NAME_MAX_LENGTH })}
         defaultValue={null}
      />
   );
};
